export default function AdminHeader() {
  return (
    <div className="admin__header">
      <img src="/images/latitude-logo.svg" alt="" />
    </div>
  )
}